module.exports = __webpack_public_path__ + "img/pancakes.3c1c28a3.jpg";